module.exports = __webpack_public_path__ + "static/media/2017РУБОксанаСуховаИвановскаяобласть.png";